import { render, staticRenderFns } from "./ApproveFileModal.vue?vue&type=template&id=5e15e664"
import script from "./ApproveFileModal.vue?vue&type=script&lang=js"
export * from "./ApproveFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports